import React, { createContext, JSX, useContext } from 'react';
import { datadogRum } from '@datadog/browser-rum';

import { useDataDogRum } from '@/shared/hooks/useDataDogRum';

type DataDogProviderProps = {
    children: JSX.Element;
};

export const DataDogContext = createContext<typeof datadogRum | null>(null);

export const DataDogProvider = ({ children }: DataDogProviderProps) => {
    const dataDog = useDataDogRum();

    return <DataDogContext.Provider value={dataDog}>{children}</DataDogContext.Provider>;
};

export const useDataDog = () => useContext(DataDogContext);
